import { ConditionAnd } from './types/conditionAnd';
import { LastNotification } from './common/LastNotification';

interface AlertRecipient {
  name: string;
  email: string;
}
export interface AlertGroupTarget {
  type: string;
  message: string;
  recipients?: AlertRecipient[];
  subject?: string;
  phoneNumbers?: string[];
}
export interface AlertGroupView {
  type: string;
  fields: number[];
}
export class AlertGroup {
  id: number;
  title: string;
  message: string;
  image: string;
  enabled: boolean;
  condition: any;
  targets: AlertGroupTarget[];
  views: AlertGroupView[];
  lastNotification: LastNotification;
  typology: Array<any>;
  alerts?: Array<any>;
  cropIds?: Array<any>;
  fieldIds?: Array<any>;
  userIds?: Array<any>;
  dateCreated?: Date;

  constructor() {
    this.id = null;
    this.title = null;
    this.message = null;
    this.image = null;
    this.enabled = true;
    this.condition = new ConditionAnd();
    this.targets = [];
    this.views = [];
    this.typology = [];
  }
}
